/* eslint-disable @typescript-eslint/ban-ts-comment, unicorn/no-abusive-eslint-disable */
// @ts-nocheck
/* eslint-disable */
import { useEffect } from "react";
import { getRandomIntercomId } from "../lib/utils";

declare global {
  interface Window {
    Intercom: any;
    intercomSettings: any;
  }
}

export const useIntercom = () => {
  useEffect(() => {
    const appId = process.env.REACT_APP_INTERCOM_APP_ID;

    if (!appId) {
      console.error("intercom environment variable is not set");
      return;
    }
    const guestId = getRandomIntercomId();
    window.intercomSettings = {
      api_base: "https://api-iam.intercom.io",
      app_id: appId,
      user_active_company_id: -1,
      anonymous_id: guestId,
      page_title: "calo-affiliates-portal",
    };

    (function () {
      var w = window;
      var ic = w.Intercom;
      if (typeof ic === "function") {
        ic("reattach_activator");
        ic("update", w.intercomSettings);
      } else {
        var d = document;
        var i = function () {
          i.c(arguments);
        };
        i.q = [];
        i.c = function (args: any) {
          i.q.push(args);
        };
        w.Intercom = i;
        var l = function () {
          var s = d.createElement("script");
          s.type = "text/javascript";
          s.async = true;
          s.src = `https://widget.intercom.io/widget/${appId}`;
          var x = d.getElementsByTagName("script")[0];
          x.parentNode!.insertBefore(s, x);
        };
        if (document.readyState === "complete") {
          l();
        } else if ((w as any).attachEvent) {
          (w as any).attachEvent("onload", l);
        } else {
          w.addEventListener("load", l, false);
        }
      }
    })();
  }, []);

  const bootIntercom = (settings: any) => {
    const appId = process.env.REACT_APP_INTERCOM_APP_ID;

    if (!appId) {
      console.error("intercom environment variable is not set");
      return;
    }

    if (window.Intercom) {
      window.Intercom("update", settings);
    }
  };

  const shutdownIntercom = () => {
    if (window.Intercom) {
      window.Intercom("update", {
        id: null,
        name: null,
        email: null,
        phone: null,
        page_title: null,
        anonymous_id: getRandomIntercomId(),
        page_title: "calo-affiliates-portal",
      });
    }
  };

  return { bootIntercom, shutdownIntercom };
};
